import React, { useState } from "react";
import "../../pages/Inventory/Inventory.css";
// import { addInventory } from "../../network/api/endpoints";
import db from "../../assets/db/main-db.json";
import Toast from "../../components/common/Toast"; 
import * as XLSX from "xlsx";
import loader from '../../assets/loader-imagine.gif'
function RawGoods() {
  const [inventoryList, setInventoryList] = useState([]);
  const [formData, setFormData] = useState({
    brand: "",
    variant: "",
    model: "",
    condition: "",
    purchasePrice: "",
    sellingPrice: "",
    notes: "",
    imei_1: "",
    imei_2: "",
  });

  const allBrands = db.brands;

  const [showDetails, setShowDetails] = useState(null);
  const [allModels, setAllModels] = useState([]);
  const [allVariants, setAllVariants] = useState([]);
  const [selectedImage, setSelectedImage] = useState(null);
  const [isLoading, setIsLoading] = useState(false);
  const allCondition = ["Silver", "Gold", "Platinum"];

  const handleModelChange = (e) => {
    const selectedBrand = e.target.value;

    // When brand changes, reset model and variant
    const models =
      allBrands.find((brand) => brand.name === selectedBrand)?.models || [];
    setAllModels(models);

    setFormData({
      ...formData,
      brand: selectedBrand,
      model: "",
      variant: "",
    });
    setAllVariants([]);
    setSelectedImage(null);
  };

  const handleVariantChange = (e) => {
    const selectedModel = e.target.value;
    const models = allModels.find((model) => model.name === selectedModel);
    setAllVariants(models?.variants || []);
    setSelectedImage(models?.imageUrl || "");
    setFormData({ ...formData, model: selectedModel, variant: "" });
  };

  const handleChange = (e) => {
    const { name, value } = e.target;

    setFormData({ ...formData, [name]: value });
  };

  const handleSubmit = () => {
    setInventoryList([...inventoryList, formData]);

    setFormData({
      brand: "",
      model: "",
      variant: "",
      condition: "",
      purchasePrice: "",
      sellingPrice: "",
      notes: "",
      imei_1: "",
      imei_2: "",
    });

    setAllModels([]);
    setAllVariants([]);
    setSelectedImage(null);
  };

  const toggleDetails = (index) => {
    setShowDetails(showDetails === index ? null : index);
  };

  const deleteItem = (index) => {
    setInventoryList(inventoryList.filter((_, i) => i !== index));
  };

  //   final submit 

  const handleFinalSubmit = async () => {
    setIsLoading(true);
    try {
      const addedItems = [];

      // Send data to the database
    //   for (const item of inventoryList) {
    //     const addedItem = await addInventory(item);
    //     addedItems.push(addedItem);
    //   }

      // If the database upload is successful, export to Excel
    //   if (addedItems.length > 0) {
    //     exportToExcel(addedItems); // Pass the uploaded items for export
    //     showToastNotification("Data successfully saved and exported!");
    //   }

      // Clear inventory list after successful submission
      setInventoryList([]);
    } catch (error) {
      showToastNotification(`Error: ${error.message}`);
    } finally {
      setIsLoading(false);
    }
  };


  // Export to Excel function
//   const exportToExcel = (addedItems) => {
//     if (addedItems.length === 0) {
//       showToastNotification("No inventory to export!");
//       return;
//     }

//     // Convert addedItems to a worksheet
//     const worksheet = XLSX.utils.json_to_sheet(addedItems);
//     const workbook = XLSX.utils.book_new();
//     XLSX.utils.book_append_sheet(workbook, worksheet, "Inventory");

//     // Write the Excel file
//     XLSX.writeFile(workbook, "InventoryList.xlsx");
//   };




  const [toastMessage, setToastMessage] = useState("");
  const [showToast, setShowToast] = useState(false);

  const showToastNotification = (message) => {
    setToastMessage(message);
    setShowToast(true);
    setTimeout(() => {
      setShowToast(false);
    }, 3000);
  };

  return (
    <>

      {
        isLoading ? (
          <img src={loader} alt="loading" className="w-1/4 self-center" />
        ) :
          (
            <div className="container">
              {/* Add Inventory */}
              <div className="add-inventory text-black" >
                <h2>Add a Raw Good</h2>
                <div className="form-group">
                  <div style={{ display: "flex", width: "100%" }}>
                    <div className="select-side">
                      <select name="brand" onChange={handleModelChange} required>
                        <option value="">Select Brand</option>
                        {allBrands.map((brand) => (
                          <option key={brand.name} value={brand.name}>
                            {brand.name}
                          </option>
                        ))}
                      </select>

                      <select
                        name="model"
                        value={formData.model}
                        onChange={handleVariantChange}
                        required
                        disabled={!formData.brand}
                      >
                        <option value="Select Model">Select Model</option>
                        {allModels.map((model) => (
                          <option key={model.id} value={model.name}>
                            {model.name}
                          </option>
                        ))}
                      </select>

                      <select
                        name="variant"
                        value={formData.variant}
                        onChange={handleChange}
                        required
                        disabled={!formData.model}
                      >
                        <option value="">Select Variant</option>
                        {allVariants.map((variant) => (
                          <option key={variant.variant} value={variant.variant}>
                            {variant.variant}
                          </option>
                        ))}
                      </select>
                      <select
                        name="condition"
                        value={formData.condition}
                        required
                        onChange={handleChange}
                      >
                        <option value="">Select Condition</option>{" "}
                        {/* Add a placeholder */}
                        {allCondition.map((condition) => (
                          <option key={condition} value={condition}>
                            {condition}
                          </option>
                        ))}
                      </select>
                    </div>

                    <div className="img-side animate-bounce	 ">
                      {selectedImage && <img src={selectedImage} alt="Preview" />}
                    </div>
                  </div>

                  <input
                    type="number"
                    name="purchasePrice"
                    placeholder="Purchase Price"
                    value={formData.purchasePrice}
                    onChange={handleChange}
                  />
                  <input
                    type="number"
                    name="sellingPrice"
                    placeholder="Selling Price"
                    value={formData.sellingPrice}
                    onChange={handleChange}
                  />
                  {/* <input
                        type="number"
                        name="quantity"
                        placeholder="Quantity"
                        value={formData.quantity}
                        onChange={handleChange}
                    /> */}

                  <input
                    type="number"
                    name="imei_1"
                    placeholder="IMEI No.1"
                    value={formData.imei_1}
                    onChange={handleChange}
                  />
                  <input
                    type="number"
                    name="imei_2"
                    placeholder="IMEI No.2"
                    value={formData.imei_2}
                    onChange={handleChange}
                  />
                  <input
                    type="text"
                    name="notes"
                    placeholder="Additional Note"
                    value={formData.notes}
                    onChange={handleChange}
                  />
                  <button onClick={handleSubmit}>Add</button>
                  {showToast && (
                    <Toast
                      message={toastMessage}
                      onClose={() => setShowToast(false)}
                    />
                  )}
                </div>
              </div>

              {/* Inventory List */}
              <div className="inventory-list">
                <h2>Raw Goods List</h2>
                {inventoryList.map((item, index) => (
                  <div key={index} className="inventory-item">
                    <div className="item-header">
                      <div className="item-name" onClick={() => toggleDetails(index)}>
                        <span className="toggle-icon">
                          {showDetails === index ? "▼" : "▶"}
                        </span>
                        <span>
                          {item.brand} - {item.model}
                        </span>
                      </div>

                      <button
                        className="delete-button"
                        onClick={() => deleteItem(index)}
                      >
                        Delete
                      </button>
                    </div>
                    {showDetails === index && (
                      <div className="item-details">
                        <p>Purchase Price: {item.purchasePrice}</p>
                        <p>Selling Price: {item.sellingPrice}</p>
                        <p>Note: {item.notes}</p>
                        <p>IMEI 1: {item.imei_1}</p>
                        <p>IMEI 2: {item.imei_2}</p>
                      </div>
                    )}
                  </div>
                ))}
              </div>
            </div>
          )
      }


      {/* Toast Notification */}

      {
        !isLoading &&
        <div
          style={{
            marginTop: "-130px",
            marginLeft: "-90px",
            display: "flex",
            alignItems: "center",
            justifyContent: "center",
            width: "110%",
            padding: "15px",
            background:
              "linear-gradient(to right, rgba(255, 0, 0, 0) 5%, #F70D1A 50%, rgba(255, 0, 0, 0) 95%)",
          }}
        >
          <button
            onClick={handleFinalSubmit}
            style={{
              width: "200px",
              backgroundColor: "white",
              color: "black",
              fontSize: "large",
            }}
          >
            Save
          </button>
          {loader && (
            <div
              className="loader"
              style={{
                display: "flex",
                justifyContent: "center",
                margin: "20px 0",
              }}
            />
          )}
        </div>
      }

    </>
  );
}

export default RawGoods;